import { ComponentStyleProps } from "../../../../../lib/styles/props/component-style-props";
import {
  CMButtonSearchConditionMaster,
  SearchDropdownDisplayValue,
} from "@pscsrvlab/psc-react-components";
import React from "react";
import { hasValue } from "../../../../../lib/util/common-util";
import log from "loglevel";
import useCustomToast from "../../../../../hooks/use-custom-toast";
import { stockRequestApi } from "../../../../../store/api/enhanced-api";
import { errorMessageOf } from "../../../../../lib/util/error-util";
import { useAppTranslation } from "../../../../../hooks/use-app-translation";

export type ButtonSearchConditionUserProps = {
  label: string;
  placeholder?: string;

  /**
   * 値。ユーザーID。
   */
  value?: number | null;

  hideClearButton?: boolean;
  searchResultNone: string;

  onChange?: (value: number | null) => void;
} & ComponentStyleProps;
export const ButtonSearchConditionUser = ({
  label,
  placeholder = "",

  value = null,

  hideClearButton = false,
  searchResultNone,

  onChange,

  sx,
  ...rest
}: ButtonSearchConditionUserProps) => {
  const { t } = useAppTranslation();
  const { errorToast } = useCustomToast();

  const [triggerListAppUserQuery] = stockRequestApi.useLazyListAppUserQuery();

  const [triggerGetAppUserQuery] = stockRequestApi.useLazyGetAppUserQuery();

  const toDisplayValue: (
    value: number,
  ) => Promise<SearchDropdownDisplayValue> = async (value) => {
    try {
      const appUser = await triggerGetAppUserQuery({
        appUserId: value,
      }).unwrap();
      return {
        headingLabel: appUser.displayUserId,
        mainLabel: appUser.fullName ?? "",
      };
    } catch (e) {
      log.error(errorMessageOf(e));
      return { headingLabel: undefined, mainLabel: "" };
    }
  };

  const handleSearch: (text: string) => Promise<number[]> = async (
    text: string,
  ) => {
    try {
      const selectableAppUsers: number[] = (
        await triggerListAppUserQuery({
          fullName: text,
        }).unwrap()
      )
        .map((v) => v?.id)
        .filter(hasValue);
      return selectableAppUsers;
    } catch (e) {
      log.error(errorMessageOf(e));
      errorToast(t("mes.汎用エラーメッセージ"));
      return [];
    }
  };

  const capitalizedLabel = label;

  return (
    <CMButtonSearchConditionMaster<number>
      label={capitalizedLabel}
      placeholder={placeholder}
      menuShowMaxCount={30}
      value={value}
      hideClearButton={hideClearButton}
      labelSubmit={t("btn.確定ボタン")}
      labelClear={t("btn.クリアボタン")}
      searchResultNone={searchResultNone}
      toDisplayValue={toDisplayValue}
      onSearch={handleSearch}
      onChange={onChange}
      sx={sx}
      {...rest}
    />
  );
};
